export default __webpack_public_path__ + "static/temp-icon-3bf8c4a13fe3078091bfb75637cd8bec.jpg";